// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const rentalRoutes = [
  route('create', '/create', Create, meta('Adicionar Locação de Unidade', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Locação de Unidade', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Locação de Unidade', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/rental/unit', rentalRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/rental/routes.js